<template lang="html">

  <section class="contacto">
    <formulario></formulario>
  </section>

</template>

<script lang="js">
  
  import formulario from '@/components/view-parts/contacto/formulario'

  export default  {
    name: 'contacto',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    components: {
     formulario
    }
}
</script>

<style scoped lang="scss">
  .contacto {

  }
</style>



// WEBPACK FOOTER //
// src/components/views/contacto.vue